<div class="overview-container">

    <!-- Green gradient banner -->
    <app-billing-summary-header [data]="mergedData"></app-billing-summary-header>
  
    <!-- Contract section -->
    <app-contracts-table [data]="mergedData"></app-contracts-table>
  
  </div>
  